module.exports = __webpack_public_path__ + "img/chat_widget_header_text.d25ad6f5.png";